import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/cosborn_text.png'


const _hoisted_1 = {
  key: 0,
  class: "link-image",
  alt: "cosborn",
  src: _imports_0
}
const _hoisted_2 = { key: 1 }


import { scrollToTop } from '@/helpers/helpers'

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomRouterLink',
  props: {
    type: null,
    to: null,
    text: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    class: _normalizeClass(`custom-router-link-${__props.type}`),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(scrollToTop)())),
    to: __props.to
  }, {
    default: _withCtx(() => [
      (__props.type==='big')
        ? (_openBlock(), _createElementBlock("img", _hoisted_1))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default"),
            _createTextVNode(" " + _toDisplayString(__props.text), 1)
          ]))
    ]),
    _: 3
  }, 8, ["class", "to"]))
}
}

})